import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CheckBox from "../common/CheckBox";
import PlainCheckBox from "../common/PlainCheckBox";
import { useSelector } from "react-redux";
import { checkCrud } from "../../helpers/userRolesHelper";

interface Props {
    data: any;
    enabled?: boolean;
    onCrudChange: any;
}

require("./UserRole.css");

const UserRole = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'Users.Popup.UserRoles' });

    const [canCreate, setCreate] = useState(false);
    const [canRead, setRead] = useState(false);
    const [canUpdate, setUpdate] = useState(false);
    const [canDelete, setDelete] = useState(false);
    const [isAdmin, setAdmin] = useState(false);


    const userInfo = useSelector((state: any) => state.userInfo);

    useEffect(() => {
        const crud = props.data.crud;
        const r = crud.includes('read') && checkCrud(props.data.name, 'read', userInfo);
        setRead(r);
        const c = crud.includes('create') && checkCrud(props.data.name, 'create', userInfo);
        setCreate(c);
        const u = crud.includes('update') && checkCrud(props.data.name, 'update', userInfo);
        setUpdate(u);
        const d = crud.includes('delete') && checkCrud(props.data.name, 'delete', userInfo);
        setDelete(d);
        const a = crud.includes('admin') && checkCrud(props.data.name, 'admin', userInfo);
        setAdmin(a);
    }, [props.data.crud, userInfo]);

    const addCrud = (value: string) => {
        let newCrud = props.data.crud;
        if (!newCrud.includes(value)) {
            newCrud.push(value);
        }
        return newCrud;
    }

    const removeCrud = (value: string) => {
        let newCrud = props.data.crud;
        if (newCrud.includes(value)) {
            const index = newCrud.indexOf(value);
            newCrud.splice(index, 1);
        }
        return newCrud;
    }

    const handleCreateChange = (val) => {
        if (val) {
            let newCrud = addCrud('create');
            props.onCrudChange(newCrud, props.data.name);
        }
        else {
            let newCrud = removeCrud('create');
            props.onCrudChange(newCrud, props.data.name);
        }
    };

    const handleReadChange = (val) => {
        if (val) {
            let newCrud = addCrud('read');
            props.onCrudChange(newCrud, props.data.name);
        }
        else {
            let newCrud = removeCrud('read');
            props.onCrudChange(newCrud, props.data.name);
        }
    };

    const handleUpdateChange = (val) => {
        if (val) {
            let newCrud = addCrud('update');
            props.onCrudChange(newCrud, props.data.name);
        }
        else {
            let newCrud = removeCrud('update');
            props.onCrudChange(newCrud, props.data.name);
        }
    };

    const handleDeleteChange = (val) => {
        if (val) {
            let newCrud = addCrud('delete');
            props.onCrudChange(newCrud, props.data.name);
        }
        else {
            let newCrud = removeCrud('delete');
            props.onCrudChange(newCrud, props.data.name);
        }
    };

    const handleAdminChange = (val) => {
        if (val) {
            let newCrud = addCrud('admin');
            props.onCrudChange(newCrud, props.data.name);
        }
        else {
            let newCrud = removeCrud('admin');
            props.onCrudChange(newCrud, props.data.name);
        }
    };

    return (
        <>
            <div className="row userRoles-row">
                <label className='col-sm-2 col-form-label zvlabel'>
                    {t(`${props.data.name}`)}
                </label>
                <PlainCheckBox id={""} disabled={!checkCrud(props.data.name, 'read', userInfo)} onCheckedChange={handleReadChange} defaultValue={canRead} />
                <PlainCheckBox id={""} disabled={!checkCrud(props.data.name, 'create', userInfo)} onCheckedChange={handleCreateChange} defaultValue={canCreate} />
                <PlainCheckBox id={""} disabled={!checkCrud(props.data.name, 'update', userInfo)} onCheckedChange={handleUpdateChange} defaultValue={canUpdate} />
                <PlainCheckBox id={""} disabled={!checkCrud(props.data.name, 'delete', userInfo)} onCheckedChange={handleDeleteChange} defaultValue={canDelete} />
                <PlainCheckBox id={""} disabled={!checkCrud(props.data.name, 'admin', userInfo)} onCheckedChange={handleAdminChange} defaultValue={isAdmin} />
            </div>
        </>
    );
}

export default UserRole;